import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Tick from "../../../../../icons/tick.svg";
import Cross from "../../../../../icons/cross.svg";
import Minus from "../../../../../icons/minus.svg";
import Documento from "../../../../../icons/document.svg";
import { Link } from "react-router-dom";
import { abrirArchivo } from "../../../../../providers/documentos";
import BreadCrumb from "../../../../../components/navbar/Breadcrumb";
import { cambiarFormatoNombre } from "../../../../../functions/funciones";
import Comentarios from "../../../../../components/proveedores/comentarios";
import ReclamacionesTimeline from "../../../../../components/proveedores/ReclamacionesTimeline";
import { getReclamacionesProveedor } from "../../../../../services/proveedor.service";

const DOCS_CUENTA_AJENA = ['formacion', 'EPIS', 'aptitud_medica'];
const DOCS_AUTONOMOS = ['recibo_autonomos', 'formacion_prl', 'documentacion_prl'];

function ProveedorOriginal({ proveedor, fincas, trabajadores = [], user }) {
  const { t } = useTranslation(['suppliers', 'properties', 'common']);

  const [reclamaciones, setReclamaciones] = useState([]);
  const [loadingReclamaciones, setLoadingReclamaciones] = useState(true);

  useEffect(() => {
    if (!proveedor?.id) return;
    setLoadingReclamaciones(true);
    getReclamacionesProveedor(proveedor.id)
      .then((res) => setReclamaciones(Array.isArray(res) ? res : []))
      .catch(() => setReclamaciones([]))
      .finally(() => setLoadingReclamaciones(false));
  }, [proveedor?.id]);

  const DOC_LABELS = {
    formacion: t('common:workers.documents.training', { defaultValue: 'Formación' }),
    EPIS: t('common:workers.documents.epis', { defaultValue: 'EPI' }),
    aptitud_medica: t('common:workers.documents.medicalFitness', { defaultValue: 'Aptitud' }),
    recibo_autonomos: t('common:workers.documents.selfEmployedReceipt', { defaultValue: 'Recibo autónomos' }),
    formacion_prl: t('common:workers.documents.prlTraining', { defaultValue: 'Form. PRL' }),
    documentacion_prl: t('common:workers.documents.prlDocumentation', { defaultValue: 'Doc. PRL' }),
  };

  return (
    <>
      <BreadCrumb rutas={[{ path: '/proveedores/', label: t('title') }, { path: `/proveedores/${proveedor?.nif}`, label: `${proveedor?.razonSocial}` }]} style={{ margin: '0 10px' }} />
      <div className="pageGrid">
        <div className="gridCard">
          <div className="gridHead">{t('sections.generalInfo')}</div>
          <div className="gridSubhead">{t('sections.companyData')}</div>
          <div className="datosGrid">
            <p><b>{t('detail.supplierName')}</b> {proveedor.razonSocial}</p>
            <p><b>{t('common:form.address')}:</b> {proveedor.direccion}</p>
            <p><b>{t('common:form.nif')}:</b> {proveedor.nif}</p>
            <p><b>{t('columns.municipality')}:</b> {cambiarFormatoNombre(proveedor?.municipio)}</p>
            <p><b>{t('detail.contactPerson')}</b> {proveedor.nombreContacto}</p>
            <p><b>{t('common:form.postalCode')}:</b> {proveedor.codigoPostal}</p>
            <p><b>{t('common:form.email')}:</b> {proveedor.emailContacto}</p>
            <p><b>{t('detail.loginEmail')}</b> {proveedor.user?.email}</p>
            <p><b>{t('common:form.province')}:</b> {proveedor.provincia}</p>
            <p><b>{t('common:form.phone')}:</b> {proveedor.telefonoContacto}</p>
            <p><b>{t('detail.lastReclamation')}</b>{" "}
              {proveedor.ultimaReclamacion !== undefined && proveedor.ultimaReclamacion > proveedor.createdAt
                ? new Date(proveedor.ultimaReclamacion).toLocaleDateString()
                : "-"}
            </p>
          </div>
          <div className="datosGrid" style={{ alignItems: "start" }}>
            <div>
              <Comentarios supp={proveedor} fechaDesde="2025-09-01" />
            </div>
            <div style={{ marginTop: 20 }}>
              <ReclamacionesTimeline fechas={reclamaciones} loading={loadingReclamaciones} t={t} />
            </div>
          </div>
          <div className="gridSubhead">{t('sections.companyDocuments')}</div>
          <table style={{ margin: 15 }}>
            <thead>
              <tr style={{ fontSize: 10, fontWeight: "normal", textAlign: "center" }}>
                <th></th><th></th><th style={{ margin: 5 }}>{t('common:actions.view')}</th>
              </tr>
            </thead>
            <tbody>
              {[
                { id: 2, label: "RC", noProcede: false, hasExpiry: true },
                { id: 3, label: t('documentTypes.preventiveModality'), noProcede: proveedor?.noProcede, hasExpiry: true },
                { id: 5, label: t('documentTypes.riskAssessment'), noProcede: false, hasExpiry: false },
                { id: 4, label: t('documentTypes.preventivePlanning'), noProcede: proveedor?.noProcede, hasExpiry: true },
                { id: 10, label: t('documentTypes.workersList'), noProcede: proveedor?.noProcede, hasExpiry: false },
                { id: 9, label: "RLC", noProcede: proveedor?.noProcede || proveedor?.docssupps?.find(d => d.tipoDoc === 9)?.noProcede === true || proveedor?.docssupps?.find(d => d.tipoDoc === 9)?.noProcede === 1, hasExpiry: true },
                { id: 8, label: "RNT", noProcede: proveedor?.noProcede || proveedor?.docssupps?.find(d => d.tipoDoc === 8)?.noProcede === true || proveedor?.docssupps?.find(d => d.tipoDoc === 8)?.noProcede === 1, hasExpiry: true },
                { id: 6, label: t('documentTypes.socialSecurityCertFull'), noProcede: false, hasExpiry: true },
              ].map((docDef) => {
                const doc = proveedor?.docssupps?.find(d => d.tipoDoc === docDef.id);
                return (
                  <tr key={docDef.id}>
                    <td>
                      {docDef.noProcede ? <span></span>
                        : doc?.pendiente ? <img src={Minus} alt={t('common:status.pending')} className="tableIcon" />
                        : doc?.validado && (!docDef.hasExpiry || new Date(doc?.fechaCaducidad) > new Date()) ? <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                        : <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />}
                    </td>
                    <td style={{ width: "100%" }}>
                      {docDef.label}{" "}
                      {docDef.noProcede ? (
                        <small style={{ display: "block", margin: "5px 0" }}><strong>{t('detail.notApplicable')}</strong></small>
                      ) : (
                        <small style={{ display: "block", margin: "5px 0", color: docDef.hasExpiry && doc?.fechaCaducidad && new Date(doc?.fechaCaducidad) <= new Date() ? 'red' : 'black' }}>
                          {doc?.fechaCaducidad ? new Date(doc.fechaCaducidad).toLocaleDateString() : "-"}
                        </small>
                      )}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {docDef.noProcede ? <span></span> : (
                        <img
                          style={!doc?.pendiente && !doc?.validado ? { opacity: 0.4, cursor: "default" } : {}}
                          src={Documento} alt={t('common:actions.view')} className="tableIcon"
                          onClick={() => abrirArchivo(doc?.ruta)}
                        />
                      )}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td>
                  {proveedor.declres?.find(d => d.aaff_id === user.id)?.pendiente
                    ? <img src={Minus} alt={t('common:status.pending')} className="tableIcon" />
                    : proveedor.declres?.find(d => d.aaff_id === user.id)?.validado
                    ? <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                    : <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />}
                </td>
                <td style={{ width: "100%" }}>
                  {t('documentTypes.responsibleDeclaration')}{" "}
                  <small style={{ display: "block", margin: "5px 0" }}>-</small>
                </td>
                <td style={{ textAlign: "center" }}>
                  <img
                    style={!proveedor?.declres?.find(d => d.aaff_id === user.id)?.pendiente && !proveedor?.declres?.find(d => d.aaff_id === user.id)?.validado ? { opacity: 0.4, cursor: "default" } : {}}
                    src={Documento} alt={t('common:actions.view')} className="tableIcon"
                    onClick={() => abrirArchivo(proveedor?.declres?.find(d => d.aaff_id === user.id)?.ruta)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="gridCard">
          <div className="gridHead">{t('properties:title').toUpperCase()}</div>
          <table style={{ margin: 15 }}>
            <thead><tr style={{ fontSize: 10, fontWeight: "normal", textAlign: "center" }}><th></th><th></th></tr></thead>
            <tbody>
              {!fincas?.length ? t('properties:noCommunities') :
                fincas.map((e, i) => (
                  <tr key={i}>
                    <td style={{ width: "100%", padding: "5px 0" }}><Link to={"/comunidades/" + e.nif}>{e.razonSocial}</Link></td>
                    <td style={{ textAlign: "center" }}></td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        {(() => {
          const cuentaAjena = trabajadores.filter(t => !t.autonomo || t.autonomo === 0);
          const autonomos = trabajadores.filter(t => t.autonomo === true || t.autonomo === 1);

          const renderWorkerTable = (workers, docsFields, docLabels) => (
            <table style={{ margin: 15, width: 'calc(100% - 30px)', fontSize: 14, tableLayout: 'fixed' }}>
              <colgroup>
                <col style={{ width: '20%' }} />
                <col style={{ width: '20%' }} />
                <col style={{ width: '15%' }} />
                <col style={{ width: '15%' }} />
                <col style={{ width: '15%' }} />
                <col style={{ width: '15%' }} />
              </colgroup>
              <thead>
                <tr style={{ fontSize: 13, fontWeight: "bold", textAlign: "center" }}>
                  <th style={{ textAlign: "left", padding: "8px 0" }}>{t('common:workers.name', { defaultValue: 'Nombre' })}</th>
                  <th style={{ textAlign: "left", padding: "8px 0" }}>{t('common:workers.surnames', { defaultValue: 'Apellidos' })}</th>
                  <th style={{ textAlign: "left", padding: "8px 0" }}>DNI</th>
                  {docsFields.map(field => (
                    <th key={field} style={{ padding: "8px 0", wordWrap: "break-word" }}>{docLabels[field]}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {workers.map((trab, i) => {
                  const docs = trab.documentos || [];
                  return (
                    <tr key={trab.id || i}>
                      <td style={{ padding: "5px 0", overflow: "hidden", textOverflow: "ellipsis" }}>{trab.nombre}</td>
                      <td style={{ padding: "5px 0", overflow: "hidden", textOverflow: "ellipsis" }}>{trab.apellidos}</td>
                      <td style={{ padding: "5px 0" }}>{trab.nif}</td>
                      {docsFields.map(field => {
                        const doc = docs.find(d => d.trabajador_typedoc?.nombre === field);
                        const isValid = doc?.validado && (!doc?.fecha_caducar || new Date(doc.fecha_caducar) > new Date());
                        const isNoProcede = doc?.noProcede;
                        return (
                          <td key={field} style={{ textAlign: "center", padding: "5px 0" }}>
                            {isNoProcede ? (
                              <img src={Minus} alt="No procede" className="tableIcon" />
                            ) : isValid ? (
                              <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                            ) : (
                              <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />
                            )}
                            {doc?.fecha_caducar && (
                              <small style={{ display: "block", fontSize: 10, color: new Date(doc.fecha_caducar) > new Date() ? 'black' : 'red' }}>
                                {new Date(doc.fecha_caducar).toLocaleDateString()}
                              </small>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );

          return (
            <div className="gridCard" id="trabajadores">
              <div className="gridHead">{t('common:workers.title', { defaultValue: 'TRABAJADORES' })}</div>
              {cuentaAjena.length > 0 && (
                <>
                  <div className="gridSubhead">{t('common:workers.employeeTitle', { defaultValue: 'TRABAJADORES POR CUENTA AJENA' })}</div>
                  {renderWorkerTable(cuentaAjena, DOCS_CUENTA_AJENA, DOC_LABELS)}
                </>
              )}
              {autonomos.length > 0 && (
                <>
                  <div className="gridSubhead">{t('common:workers.selfEmployedTitle', { defaultValue: 'TRABAJADORES AUTÓNOMOS' })}</div>
                  {renderWorkerTable(autonomos, DOCS_AUTONOMOS, DOC_LABELS)}
                </>
              )}
            </div>
          );
        })()}
      </div>
    </>
  );
}

export default ProveedorOriginal;
